// extracted by mini-css-extract-plugin
export default {"container":"Context_container__0-vLc","img":"Context_img__YHcgo","title":"Context_title__+dW3+","desc":"Context_desc__EVbpy"};